// extracted by mini-css-extract-plugin
module.exports = {"phaseTaskCardDelete":"IPtr2j6wNqZX04owR1EZJ","phaseTaskCard":"_2vz-FmuxR-w0oKk9Q-_-dH"};